import React, { Component } from 'react';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      num: this.props.num,
      height: 'auto',
      show: true,
    };

    this.action = this.action.bind(this);
  }

  action() {
    if (window.innerWidth < 768) {
      this.setState({ show: !this.state.show });
    }
  }

  componentDidMount() {
    var that = this;

    if (process.browser) {
      if (window.innerWidth < 768) {
        window.addEventListener('load', function () {
          const height = that.divElement.clientHeight;

          that.setState({ height: height });

          if (that.props.num !== 1) {
            that.setState({ show: false });
          }
        });
      }
    }
  }

  render() {
    return (
      <div className={'why-container mb-15 md:mb-0 ' + (this.state.show ? 'show' : 'hide')}>
        <p className="why-title relative text-purple pl-40 sm:pl-46  text-18 font-bold" onClick={this.action}>
          <span className="absolute text-green text-36 leading-none font-bold top-1/2 left-0 translate-50">{this.props.num}</span>
          {this.props.question}
        </p>

        <div
          className="relative why-content ml-8 mt-15 mb-15 pt-5 pl-30 transition-all overflow-hidden duration-300 ease-in-out"
          ref={divElement => {
            this.divElement = divElement;
          }}
          style={{ height: this.state.height }}
        >
          <p className="text-left text-16">{this.props.answer}</p>
          <style global jsx>{`
            @media screen and (max-width: 768px) {
              .hide .why-content {
                height: 0 !important;
                padding: 0 0 0 30px !important;
                margin-top: 0 !important;
                margin-bottom: 0 !important;
              }
              .hide p {
                font-weight: 500;
              }
              .why-title:before {
                content: '';
                position: absolute;
                width: 1px;
                height: calc((100% - 36px) / 2 + 15px);
                top: calc((100% - 36px) / 2 + 36px);
                left: 8px;
                background-color: #8dc63f;
              }
              .why-title:after {
                content: '';
                position: absolute;
                width: 1px;
                height: calc((100% - 36px) / 2 + 15px);
                top: -15px;
                left: 8px;
                background-color: #8dc63f;
              }
              .why-container:first-of-type .why-title:after {
                content: unset;
              }
              // .why-container:last-of-type .why-title:before{
              //     content: unset;
              // }
            }
            .why-content:before {
              content: '';
              position: absolute;
              width: 1px;
              height: 100%;
              top: 0;
              left: 0px;
              background-color: #8dc63f;
            }
          `}</style>
        </div>
      </div>
    );
  }
}

function Why(props) {
  return (
    <div className="pl-5 xs:pl-5 md:pl-5">
      {props.content.map(function (benefit, i) {
        return <Question key={i} num={i + 1} question={benefit.title} answer={benefit.answer}></Question>;
      })}
    </div>
  );
}

export default Why;
